/**
 * Created by Administrator on 2018/6/7.
 */
//1.屏幕适配px转rem，100px=1rem
function cssSize() {
	var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
	var wH = window.innerHeight; // 当前窗口的高度
	var wW = window.innerWidth; // 当前窗口的宽度
	var rem = wW * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
	$('html').css('font-size', rem + "px");

	$(window).resize(function() {
		var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
		var wH = window.innerHeight; // 当前窗口的高度
		var wW = window.innerWidth; // 当前窗口的宽度
		var rem = wW * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
		$('html').css('font-size', rem + "px");
	});
}
cssSize();

// //2.绑定除了导航以外的内容
// $(document).ready(function() {
//     $("body *:not('#except')").mouseover(function() {
//         console.log(111111);
//     });
// })

//判断图片是否存在
//function CheckImgExists(imgurl) {
//	var ImgObj = new Image(); //判断图片是否存在  
//	ImgObj.src = imgurl;  
//	console.log(ImgObj);
//	//没有图片，则返回-1  
//	if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) { 
//		console.log(imgurl)
//	  return true;  
//	} else {  
//		console.log(11111)
//	  return false;
//	}  
//	console.log(ImgObj)

//	var oreq = new ActiveXObject("Microsoft.XMLHTTP");
//	oreq.open("Get", "http://10.60.1.29:8080/static/img/1.jpg", false);
//	oreq.send();
//	alert(oReq.status)
//	if(oReq.status == 404)
//		alert('不存在');
//	else
//		alert("存在")
//}



// WEBPACK FOOTER //
// ./src/common/js/common.js